import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Slider extends Component {
  constructor(props) {
    super(props);

    this.slickOptions = props.slickOptions || {};

    this.sliderRef = React.createRef();
    this.instance = null;

    this.init = this.init.bind(this);
    this.destroy = this.destroy.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate() {
    this.init();
  }

  componentWillUnmount() {
    this.destroy();
  }

  init() {
    if (!this.instance) {
      const sliderElement = window.jQuery(this.sliderRef.current);
      this.instance = sliderElement.slick(this.slickOptions);
    }
  }

  destroy() {
    if (this.instance) {
      this.instance.slick('unslick');
      this.instance = null;
    }
  }

  render() {
    this.destroy();
    const { id, className, children } = this.props;
    return (
      <div ref={this.sliderRef} id={id} className={className}>
        {children}
      </div>
    );
  }
}

Slider.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  slickOptions: PropTypes.shape({
    slidesToScroll: PropTypes.number,
    slidesToShow: PropTypes.number,
    arrows: PropTypes.bool,
    rows: PropTypes.number,
    infinite: PropTypes.bool,
    variableWidth: PropTypes.bool,
  }),
};

Slider.defaultProps = {
  id: '',
  className: '',
  children: [],
  slickOptions: {},
};

export { Slider };
